<template>
  <bs-modal
    name="survey"
    :ok-title="$t('javascript.go_to_survey')"
    :cancel-title="$t('javascript.cancel')"
    @ok="okClicked"
    :value="value"
    @input="$emit('input', $event)"
  >
    <form>
    <h3> {{ $t('javascript.do_you_want_to') }} </h3>

    </form>
  </bs-modal>
</template>

<script>
  import BsModal from './bs_modal'

  export default {
    name: "survey-modal",
    props: {
      value: {
        type: Boolean,
        default: false
      },
      surveyId: {
        type: Number,
        default: 0
      },
      partyId: {
        type: Number,
        default: 0
      },
      completed: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
      }
    },
    components: {BsModal},
    methods: {
      okClicked() {
        window.location = window.location.href.replace(/cases\/\d+\/[^\/]*$/, 'survey/surveys/' + this.surveyId + '/attempts/new?party_id=' + this.partyId);
        return
      }, handleADC(){
      },
      goToSurvey(){
      },
    },
  }
</script>
